module.exports = "<mat-icon svgIcon=\"pencil\" (click)=\"openDialog()\"></mat-icon>";